module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Patch-7e345854177f6e353aaaafdf618365cec03d658c91b235d064590d1b92efaca7.svg";